<template>
  <div>
    <Sidebar></Sidebar>
    <Header></Header>
    <b-container fluid>
      <b-row>
        <b-col>
          <h3 class="my-4">Contato:</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table striped hover :items="items" :fields="fields">
            <template slot="visualizar" slot-scope="data">
              <div class="icon-eye">
                <i class="fas fa-eye" @click="showModal(data.item.id)"></i>
              </div>
            </template>
            <template slot="read" slot-scope="data">
              {{ booleanText(data.item.read) }}
            </template>
            <template slot="timestamp" slot-scope="data">
              {{ data.item.timestamp | moment("DD/MM/YYYY hh:mm:ss") }}
            </template>
          </b-table>

          <div v-show="loading" class="loading-holder">
            <div class="loading-spinner"></div>
          </div>
        </b-col>
      </b-row>

      <v-pagination
        class="f-right mt-3"
        v-model="currentPage"
        :page-count="pages"
      ></v-pagination>
    </b-container>

    <b-modal ref="modal-message" :title="currentMessage.subject" hide-footer>
      <b>{{ currentMessage.name }}</b> (<i>{{ currentMessage.email }}</i
      >) em <b>{{ currentMessage.timestamp | moment("DD/MM/YYYY") }}</b>
      <p class="mt-4">
        {{ currentMessage.message }}
      </p>
    </b-modal>
  </div>
</template>

<script>
import http from "@/http";
import router from "@/router";
import authentication from "../util/authentication";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import vPagination from "vue-plain-pagination";

export default {
  name: "Newsletter",
  data() {
    return {
      entity: {
        eng: "Contact",
        por: "Contato"
      },
      fields: [
        "visualizar",
        {
          key: "name",
          label: "Nome",
          sortable: false
        },
        {
          key: "email",
          label: "Email",
          sortable: false
        },
        {
          key: "subject",
          label: "Assunto",
          sortable: false
        },
        {
          key: "read",
          label: "Lido",
          sortable: false
        },
        {
          key: "timestamp",
          label: "Data",
          sortable: false
        }
      ],
      items: [],
      currentPage: 1,
      pages: 1,
      currentMessage: {
        name: "",
        email: "",
        subject: "Bla",
        message: "",
        timestamp: ""
      },
      loading: true
    };
  },
  components: {
    Sidebar,
    Header,
    Footer,
    vPagination
  },
  methods: {
    list() {
      http
        .get(
          `${this.entity.eng}?page=${this.currentPage - 1}`,
          authentication.getHeaders()
        )
        .then(res => {
          this.items = res.data.list;
          this.pages = res.data.pages;
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    booleanText(value) {
      return value ? "Sim" : "Não";
    },
    showModal(messageId) {
      http
        .get(`${this.entity.eng}/${messageId}`, authentication.getHeaders())
        .then(res => {
          this.currentMessage = res.data;
          this.$refs["modal-message"].show();
        });
    }
  },
  created() {
    this.list();
  },
  watch: {
    currentPage() {
      this.list();
    }
  }
};
</script>

<style scoped>
.icon-eye {
  cursor: pointer;
  color: #007bff;
}

.icon-eye:hover {
  color: #0056b3;
}
</style>



// WEBPACK FOOTER //
// src/views/Contact.vue